import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
} from "@angular/router";
import { UserService } from "../services/user/user.service";

@Injectable({
  providedIn: "root",
})
export class LogoutGuard {
  constructor(
    private userService: UserService,
  ) {}

  canActivate = async (route:ActivatedRouteSnapshot, state:RouterStateSnapshot): Promise<boolean> => {
    const token = await this.userService.ensureValidSession();

    return !token;
  }
  

    
  
}
